import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import styles from "./../AldCupidId.module.scss";
import thresholdStyles from "../paymentThreshold/PaymentThreshold.module.scss";
import { withTranslation } from "react-i18next";
import EditIcon from "../../../shared/Edit/EditIcon";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import MarketPreferencesClient from "../../../shared/clients/MarketPreferencesClient";
import HasPermissionTo from "../../../common/HasPermissionTo";
import PendingActionClient from "../../../shared/clients/PendingActionClient";
import { PAYMENT_THRESHOLD } from "../../../common/Constants";
import { IS_HUNGARY_MARKET } from "../../../utils/EmpUtil";

class PaymentThreshold extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      paymentThreshold: undefined,
      paymentThresholdCopy: undefined,
      saved: false,
      maxLimitFormatted: "",
      validationMaxLimitMsg: "",
    };
  }

  componentDidMount() {
    this.props.hideOrShow(true);
    MarketPreferencesClient.getPaymentThreshold(
      this.props.user,
      this.props.selectedMarket
    )
      .then((response) => {
        const paymentThresholdFromDB = response.result.paymentThreshold;
        this.setState({
          paymentThreshold: paymentThresholdFromDB || "",
          paymentThresholdCopy: paymentThresholdFromDB || "",
        });
      })
      .catch(() => {})
      .finally(() => {
        this.props.hideOrShow(false);
      });

    this.setState({
      validationMaxLimitMsg:
        this.props.t("PaymentThreshold.validations.maxLimit") || "",
      maxLimitFormatted: IS_HUNGARY_MARKET(this.props.selectedMarket)
        ? "999,999.99"
        : "99,999.99",
    });
  }

  handleEdit = () => {
    this.setState({ editMode: true, saved: false });
  };

  handleBlur = (e) => {
    if (e.target.value) {
      if (this.paymentThresholdRef.current.isValid()) {
        this.setState({ editMode: false });
      }
    }
  };

  handleChange = (event) => {
    this.setState({ paymentThreshold: event.target.value });
  };

  handleSubmit = () => {
    this.props.hideOrShow(true);

    const paymentThresholdRequest = {
      paymentThreshold: this.state.paymentThreshold,
    };

    MarketPreferencesClient.savePaymentThresholdPreferences(
      this.props.user,
      paymentThresholdRequest,
      this.props.selectedMarket
    )
      .then(() => {
        this.setState({
          editMode: false,
          paymentThresholdCopy: this.state.paymentThreshold,
          saved: true,
        });
        PendingActionClient.removeNscPendingAction(
          this.props.user,
          PAYMENT_THRESHOLD,
          null,
          this.props.selectedMarket
        );
      })
      .finally(() => this.props.hideOrShow(false));
  };

  paymentThresholdRef = React.createRef();

  render() {
    return (
      <div className="pageWrapper">
        <ValidatorForm onSubmit={this.handleSubmit}>
          <div className="pagePaddingTop">
            <Grid container className={styles.divider}>
              <Grid item xs={6}>
                <div className={`${styles.header} ${styles.leftAlignment}`}>
                  {this.props.t("PaymentThreshold.typeColumnCaption")}
                </div>
              </Grid>
              <Grid item xs={6}>
                <div className={`${styles.header} ${styles.rightAlignment}`}>
                  <div>
                    {this.props.t("PaymentThreshold.amountColumnCaption")}
                  </div>
                  <HasPermissionTo
                    perform={["paymentThreshold:write"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    condition={!this.state.editMode}
                    render={() => {
                      return (
                        <div className={styles.icon} onClick={this.handleEdit}>
                          <EditIcon id="PaymentThreshold" />
                        </div>
                      );
                    }}
                  />
                </div>
              </Grid>
            </Grid>

            <Grid container className={styles.rowDivider}>
              <Grid item xs={6}>
                <div className={`${styles.leftAlignment} ${styles.aldCupidId}`}>
                  {this.props.t("PaymentThreshold.rowDescription")}
                </div>
              </Grid>
              <Grid item xs={6}>
                <div
                  className={`${styles.rightAlignment} ${styles.textBoxCell}`}
                >
                  {this.state.editMode ? (
                    <div className={thresholdStyles.amountColumn}>
                      <div>
                        {this.props.localizedInfo.defaultCurrency.symbol} &nbsp;
                      </div>
                      <TextValidator
                        onBlur={this.handleBlur}
                        ref={this.paymentThresholdRef}
                        data-testid="thresholdInputTestId"
                        name="thresholdInputName"
                        className={styles.inputField}
                        variant="outlined"
                        value={this.state.paymentThreshold}
                        onChange={this.handleChange}
                        placeholder="-"
                        validators={[
                          "required",
                          "matchRegexp:^[0-9]*(\\.[0-9]{0,2})?$",
                          "minNumber:1",
                          IS_HUNGARY_MARKET(this.props.selectedMarket)
                            ? "maxNumber:999999"
                            : "maxNumber:99999",
                        ]}
                        errorMessages={[
                          this.props.t("PaymentThreshold.validations.required"),
                          this.props.t(
                            "PaymentThreshold.validations.invalidFormat"
                          ),
                          this.props.t(
                            "PaymentThreshold.validations.invalidFormat"
                          ),
                          this.state.validationMaxLimitMsg +
                            " " +
                            this.state.maxLimitFormatted,
                        ]}
                      />
                    </div>
                  ) : (
                    <div
                      className={styles.cupidIdValue}
                      data-testid="thresholdText"
                    >
                      {this.state.paymentThreshold === ""
                        ? "-"
                        : this.props.localizedInfo.defaultCurrency.symbol}
                      &nbsp; {this.state.paymentThreshold}
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
          <HasPermissionTo
            perform={["paymentThreshold:write"]}
            permissions={this.props.user.permissions.rolePermissions}
            render={() => {
              return this.state.saved ? (
                <div className={styles.saved}>
                  {this.props.t("PaymentThreshold.savedThreshold")}
                </div>
              ) : (
                <div className={styles.applyButton}>
                  <button
                    type="submit"
                    data-testid="thresholdSubmitBtn"
                    disabled={
                      this.state.paymentThreshold ===
                      this.state.paymentThresholdCopy
                    }
                  >
                    {this.props.t("OptIn.apply")}
                  </button>
                </div>
              );
            }}
          />
        </ValidatorForm>
      </div>
    );
  }
}

export default withTranslation("emp")(PaymentThreshold);
